'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _SeeInspiration = require('./SeeInspiration.scss');

var _SeeInspiration2 = _interopRequireDefault(_SeeInspiration);

var _reactIntl = require('react-intl');

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactRedux = require('react-redux');

var _customize = require('redux/modules/customize');

var _InspirationLayouts = require('components/Home/InspirationLayouts');

var _InspirationLayouts2 = _interopRequireDefault(_InspirationLayouts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  SeeInspiration: {
    displayName: 'SeeInspiration'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Home/SeeInspiration.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import Scroll from 'react-scroll';
// const Element = Scroll.Element;

// import { path } from 'utils/media';

var SeeInspiration = _wrapComponent('SeeInspiration')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    locale: state.language.locale,
    siteConfigs: state.info.siteConfigs
  };
}, { logCustomizeTrip: _customize.logCustomizeTrip }), _dec2 = (0, _reactCssModules2.default)(_SeeInspiration2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SeeInspiration, _Component);

  function SeeInspiration() {
    (0, _classCallCheck3.default)(this, SeeInspiration);
    return (0, _possibleConstructorReturn3.default)(this, (SeeInspiration.__proto__ || (0, _getPrototypeOf2.default)(SeeInspiration)).apply(this, arguments));
  }

  (0, _createClass3.default)(SeeInspiration, [{
    key: 'onClick',
    value: function onClick(id) {
      if (this.props.siteConfigs.customizeInspiration) {
        this.props.logCustomizeTrip(id);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          inspirationLayouts = _props.inspirationLayouts,
          showAllInspirations = _props.showAllInspirations,
          siteConfigs = _props.siteConfigs;

      if (!inspirationLayouts || inspirationLayouts.length === 0) {
        return _react3.default.createElement('div', null);
      }
      var _props2 = this.props,
          homeStyle = _props2.homeStyle,
          locale = _props2.locale;

      var isMerge = homeStyle && locale === 'en' || false;
      return _react3.default.createElement(
        'section',
        { id: 'see-inspirations' },
        _react3.default.createElement(
          'div',
          { styleName: isMerge ? 'container-home' : 'container', style: { backgroundColor: this.props.bgColor } },
          _react3.default.createElement(
            'div',
            { styleName: 'inner' },
            _react3.default.createElement(
              'h2',
              { styleName: 'header' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.see_inspiration.header' })
            ),
            _react3.default.createElement(
              'p',
              { styleName: 'description' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.see_inspiration.sub_header' })
            ),
            _react3.default.createElement(_InspirationLayouts2.default, { layouts: inspirationLayouts }),
            showAllInspirations && !siteConfigs.hideAllInspirations && _react3.default.createElement(
              'div',
              { styleName: 'local-wrapper' },
              _react3.default.createElement(
                _Link2.default,
                { to: "/inspiration", styleName: 'btn-all-ins' },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.see_inspiration.all_staffs_picks' })
              )
            )
          )
        )
      );
    }
  }]);
  return SeeInspiration;
}(_react2.Component), _class2.propTypes = {
  inspirationLayouts: _react2.PropTypes.array,
  showAllInspirations: _react2.PropTypes.bool,
  locale: _react2.PropTypes.string,
  siteConfigs: _react2.PropTypes.object,
  logCustomizeTrip: _react2.PropTypes.func,
  bgColor: _react2.PropTypes.string,
  homeStyle: _react2.PropTypes.bool
}, _class2.defaultProps = {
  inspirationLayouts: [],
  showAllInspirations: true,
  bgColor: '#ffffff',
  homeStyle: false
}, _temp)) || _class) || _class));

exports.default = SeeInspiration;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/SeeInspiration.js
// module id = 458
// module chunks = 47